import React from 'react';
import {Helmet, translate} from 'views/module';
import EventListView from 'views/scenes/event_list/EventListView';

const App = (props) => {
  return (
    <>
      <Helmet>
        <title>{translate('eventList.Helmet.title')}</title>
      </Helmet>
      <EventListView />
    </>
  );
};

export default App;
